<template>
  <div class="ma-4 px-4">
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :items="feeRequestYearBatchItems"
            fixed-header
            class="secondary row-height-50"
            hide-default-footer
          >
            <template #[`item.partner_id`]="{}">
              {{ getPartnerName(partner_id) }}
            </template>
            <template #[`item.program_id`]="{}">
              {{ getProgramName(program_id) }}
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3" cols="12">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          hide-details="auto"
          label="Search"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col md="3" cols="3" class="d-flex justify-end px-0">
        <v-btn
          :disabled="!studentList.length"
          small
          style="height: 40px"
          class="primary mr-3"
          @click="dialog = true"
        >
          Send Invoice
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            v-model="studentList"
            :headers="FeeRequestStudentHeaders"
            :search="search"
            :items="items"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
            show-select
            selectable-key="isSelectable"
          >
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @save="sendInvoices"
      />
    </v-dialog>
  </div>
</template>

<script>
import {
  FeeRequestStudentHeaders,
  FeeRequestHeaders,
} from "@/constants/headers";
import formDialog from "@/components/fee_invoice/schedule.vue";

export default {
  components: {
    formDialog,
  },
  data() {
    return {
      items: [],
      search: "",
      FeeRequestStudentHeaders,
      FeeRequestHeaders,
      headers: [],
      partners: [],
      programs: [],
      program_id: null,
      partner_id: null,
      year: null,
      batch: null,
      studentList: [],
      feeRequestYearBatchItems: [],
      dialog: false,
    };
  },
  created() {
    this.program_id = this.$route.query?.program_id;
    this.partner_id = this.$route.query?.partner_id;
    this.year = this.$route.query?.year;
    this.batch = this.$route.query?.batch;
    this.initialise();
  },
  methods: {
    async initialise() {
      await Promise.all([this.getPartners(), this.getPrograms()]);

      const partner = this.getPartnerName(this.partner_id);
      const program = this.getProgramName(this.program_id);
      if (!program || !partner || !this.year || !this.batch) {
        this.$store.commit("showSnackbar", {
          message: "Program or Partner Missing",
          color: "error",
        });
        this.$router.go(-1);
        return;
      }
      this.$store.commit("setBreadcrumbs", [
        { text: "Exam Invoice", to: { name: "Exam Invoice" } },
        {
          text: `${partner} - ${program}`,
          to: {
            path: "/exam-fee-request-year-batch",
            query: {
              partner_id: this.partner_id,
              program_id: this.program_id,
            },
          },
        },
        { text: `${this.year} - ${this.batch}` },
      ]);

      this.headers = this.FeeRequestHeaders.filter(
        (item) => item.value != "action"
      );
      this.headers = [
        {
          text: "Year",
          value: "year",
          class: "black--text font-weight-bold secondary",
        },
        {
          text: "Batch",
          value: "batch",
          class: "black--text font-weight-bold secondary",
        },
        ...this.headers,
      ];
      this.getFeeRequestStudents();
      this.getFeeRequestYearBatch();
    },
    async sendInvoices(form) {
      console.log(this.studentList);
      const student_ids = this.studentList.map((item) => item.id);
      await this.$axios
        .post("/create_invoices", {
          student_ids,
          type: "Exam Fee",
          ...form,
        })
        .then((res) => {
          this.dialog = false;
          console.log(res);
          this.$store.commit("showSnackbar", {
            message: "Invoices created successfully",
            color: "success",
          });
          this.studentList = [];
          this.getFeeRequestStudents();
        })
        .catch(async (error) => {
          console.log(error);
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async getPartners() {
      await this.$axios.get("/partners").then((res) => {
        this.partners = res.data.data;
      });
    },
    async getPrograms() {
      await this.$axios.get("/programs").then((res) => {
        this.programs = res.data.data;
      });
    },

    getPartnerName(id) {
      if (!id) return "";
      const partner = this.partners.find((p) => p.id == id);
      return partner ? partner.name : "";
    },

    getProgramName(id) {
      if (!id) return "";
      const program = this.programs.find((p) => p.id == id);
      return program
        ? program.degree.short_name +
            (program.specialization ? " - " + program.specialization : "")
        : "";
    },
    async getFeeRequestStudents() {
      await this.$axios
        .get("/list_students_for_exam_fee", {
          params: {
            partner_id: this.partner_id,
            program_id: this.program_id,
            year: this.year,
            batch: this.batch,
          },
        })
        .then((res) => {
          this.items = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response?.data?.message || "Failed to fetch",
            color: "error",
          });
        });
    },
    async getFeeRequestYearBatch() {
      await this.$axios
        .get("/get_exam_fee_request_by_year_batch", {
          params: {
            partner_id: this.partner_id,
            program_id: this.program_id,
            year: this.year,
            batch: this.batch,
          },
        })
        .then((res) => {
          this.feeRequestYearBatchItems = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response?.data?.message || "Failed to fetch",
            color: "error",
          });
        });
    },
    customFilter(value, search, item) {
      if (!search) return true;

      const programName = this.getProgramName(item.program_id);
      const partnerName = this.getPartnerName(item.partner_id);

      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        programName.toLowerCase().includes(search.toLowerCase()) ||
        partnerName.toLowerCase().includes(search.toLowerCase())
      );
    },
  },
};
</script>

<style></style>
